export const QUESTIONS_RECEIVED = "QUESTIONS_RECEIVED";
export const SET_QUESTION = "SET_QUESTION";
